import {
  fetchAccessRoles,
  fetchDagsLoad,
  fetchDagsTransform,
  fetchDagsPublish,
  fetchDataLicences,
  fetchGeoLevel,
  fetchDataOrganisations,
} from "@/api/dags.api"
import { useQuery } from "react-query"

import { ILoad, ITransform, IPublish, IUnpublish, IAccessRole, IGeoLevel, IDataLicence, IDataOrganisation } from "@/types/dags"

export function useGetDagsTransform(id: string) {
  return useQuery<ITransform[]>(["dagsTransform", id], () =>
    fetchDagsTransform(id),
  )
}

export function useGetDagsLoad(id: string) {
  return useQuery<ILoad[]>(["dagsLoad", id], () => fetchDagsLoad(id))
}

export function useGetDagsPublish(id: string) {
  return useQuery<IPublish[]>(["dagsPublish", id], () => fetchDagsPublish(id))
}

export function useGetAccessRoles() {
  return useQuery<IAccessRole[]>(["accessRoles"], fetchAccessRoles)
}

export function useGetGeoLevels() {
  return useQuery<IGeoLevel[]>(["geoLevel"], fetchGeoLevel)
}

export function useGetDataLicences() {
  return useQuery<IDataLicence[]>(["dataLicences"], fetchDataLicences)
}

export function useGetDataOrganisations() {
  return useQuery<IDataOrganisation[]>(["dataOrganisations"], fetchDataOrganisations)
}